import ServiceTemplate from '@/components/ServiceTemplate';

export default function ITCommercialLaw() {
  const data = {
    title: 'IT and Commercial Law Services',
    subtitle: 'Comprehensive legal services for technology companies and commercial transactions.',
    overviewTitle: 'Legal Support for Technology Businesses',
    overviewImage: 'https://images.unsplash.com/photo-1551836022-deb4988cc6c0',
    description: [
      'Technology businesses face unique legal challenges including software licensing, SaaS agreements, data protection, intellectual property, and complex commercial contracts. Specialized legal support is essential for success.',
      'Our IT and commercial law service provides comprehensive legal support for technology companies including contract drafting, licensing, compliance, and strategic guidance.',
      'We help technology businesses protect their innovations, structure commercial relationships, and navigate regulatory requirements.'
    ],
    benefits: [
      { title: 'Technology Contracts', description: 'Software licenses, SaaS agreements, and API terms.' },
      { title: 'Commercial Agreements', description: 'Vendor agreements, partnership deals, and distribution.' },
      { title: 'IP Protection', description: 'Protect software, trade secrets, and technology IP.' },
      { title: 'Regulatory Compliance', description: 'Navigate data protection and industry regulations.' },
      { title: 'Risk Management', description: 'Identify and mitigate legal risks.' },
      { title: 'Strategic Advice', description: 'Legal guidance for business growth.' }
    ],
    process: [
      { title: 'Investigation & Analysis', description: 'Comprehensive review and analysis of all relevant legal, financial, and operational factors.' },
      { title: 'Documentation & Recommendations', description: 'Detailed documentation of findings with strategic recommendations for action.' },
      { title: 'Implementation & Support', description: 'Ongoing support for implementation of recommendations and resolution of issues.' }
    ],
    pricing: [
      {
        name: 'Consultation',
        description: 'Initial assessment',
        price: '$299',
        period: 'Per session',
        features: [
          '90-minute consultation',
          'Situation analysis',
          'Strategy recommendations',
          'Action plan',
          'Written summary',
          'Follow-up email support'
        ]
      },
      {
        name: 'Retainer',
        description: 'Ongoing advisory',
        price: '$1,499',
        period: 'Per month',
        featured: true,
        features: [
          'Monthly strategy sessions',
          'Unlimited email support',
          'Priority phone access',
          'Document review',
          'Compliance monitoring',
          'Quarterly reporting',
          'Dedicated attorney'
        ]
      },
      {
        name: 'Project-Based',
        description: 'Custom engagement',
        price: 'Custom',
        period: 'Based on scope',
        features: [
          'Scope-based pricing',
          'Dedicated team',
          'Project management',
          'Milestone deliverables',
          'All work product included',
          'Comprehensive reporting',
          'Executive support'
        ]
      }
    ],
    faqs: [
      { question: 'What is a software license agreement?', answer: 'Agreement granting rights to use software, specifying permitted uses, restrictions, warranties, and liability limitations.' },
      { question: 'What is a SaaS agreement?', answer: 'Service agreement for cloud-based software including service levels, data ownership, security, and subscription terms.' },
      { question: 'How do I protect my software?', answer: 'Through copyright, patents (for algorithms), trade secrets, and restrictive licensing terms combined with technical protection.' },
      { question: 'What are API terms?', answer: 'Terms governing how third parties can access and use your API, including usage limits, data handling, and IP rights.' },
      { question: 'What about open source compliance?', answer: 'Businesses using open source must comply with license terms, which may require disclosing source code or limiting commercialization.' },
      { question: 'What is escrow for source code?', answer: 'Arrangement where source code is deposited with neutral third party for release to licensee under specified conditions (e.g., vendor bankruptcy).' },
      { question: 'Do I need terms of service?', answer: 'Yes, websites and online services should have terms of service defining user rights, restrictions, liability limitations, and dispute resolution.' },
      { question: 'What about international transactions?', answer: 'International deals require addressing jurisdiction, data protection laws, export controls, and cross-border transaction issues.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
